export const TargetProcessingStatus = {
	PROCESSING: 'processing',
	COMPLETE: 'complete',
}

export const generateTargetRef = (createdAt: string): string => {
	const timestamp = Math.floor(new Date(createdAt).getTime() / 1000)
	// Split the timestamp string into a sequence with hyphens after first 3 characters and before last 3
	const timestampStr = timestamp.toString()
	return timestampStr.length > 6
		? `${timestampStr.slice(3, -3)}-${timestampStr.slice(-3)}`
		: timestampStr
}
